(function () {
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)(2g|slow-2g)$/.test(conn.effectiveType || ''))) return;

  var seen = new Set();
  var pending = null;

  function prefetch(href) {
    if (seen.has(href)) return;
    seen.add(href);
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function eligible(a) {
    if (!a || !a.href) return null;
    if (a.origin !== location.origin) return null;
    if (a.hasAttribute('download')) return null;
    if (a.dataset.noPrefetch != null) return null;
    var url = new URL(a.href);
    if (url.pathname === location.pathname && url.search === location.search) return null;
    if (/\/cart$|\/cart\/|\/account|\/admin|\/checkout/.test(url.pathname)) return null;
    return url.href.split('#')[0];
  }

  document.addEventListener(
    'pointerover',
    function (e) {
      var a = e.target.closest && e.target.closest('a');
      var href = eligible(a);
      if (!href) return;
      if (pending) clearTimeout(pending);
      pending = setTimeout(function () {
        prefetch(href);
      }, 65);
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'pointerout',
    function (e) {
      if (e.target.closest && e.target.closest('a') && pending) {
        clearTimeout(pending);
        pending = null;
      }
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchstart',
    function (e) {
      var a = e.target.closest && e.target.closest('a');
      var href = eligible(a);
      if (href) prefetch(href);
    },
    { passive: true, capture: true }
  );
})();
